// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import {NavLink} from 'react-router-dom'
import {FormGroup, InputField} from '../../../form'
import classnames from 'classnames'
import {resetPassword} from '../../../../actions/user'

import {validatePassword} from '../../../../utils/validators'

import './index.css'

import vmxLogo from '../../../../media/VerimatrixLogo.png'
import ErrorIcon from '@material-ui/icons/Error'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'

class ResetPasswordForm extends Component {

  render () {
    const {error, handleSubmit, invalid, submitting} = this.props

    return (
      <div className='reset-password container col-lg-4 col-md-6 col-7' onClick={e => e.stopPropagation()}>
        <form className={classnames('form reset-password-form', {error})} onSubmit={handleSubmit} onMouseDown={e => e.stopPropagation()}>
          {<img src={vmxLogo} alt='Verimatrix Logo' className='vmx-logo'/>}
          <div className='reset-password-fields'>
            <label className='formLabel lblResetPassword'><ExitToAppIcon/> Reset your password</label>
            <div className='inputs'>
              <FormGroup>
                <div className='row'>
                  <div className='col-12'>
                    <label>Temporary Password</label>
                  </div>
                  <div className='col-12'>
                    <Field
                      name='temporaryPassword'
                      type='text'
                      component={InputField}
                    />
                  </div>
                </div>
              </FormGroup>
              <div className='password-rules'>
                <ul>
                  <li className='lh'>{'Make sure your password meets the following requirements:'}</li>
                  <li>{'Must be at least 10 characters'}</li>
                  <li>{'Contains at least 1 upper case and 1 lower case letter'}</li>
                  <li>{'Does not use any blank spaces'}</li>
                  <li>{'Has at least 1 number'}</li>
                  <li>Includes at least 1 symbol <span className='symbols'>{'(!”#$%&’()*+,-./:;<=>?@[\\]^_{|}~)'}</span></li>
                </ul>
              </div>
              <FormGroup>
                <div className='row'>
                  <div className='col-12'>
                    <label>New Password</label>
                  </div>
                  <div className='col-12'>
                    <Field
                      name='newPassword'
                      type='password'
                      component={InputField}
                    />
                  </div>
                </div>
              </FormGroup>
              <FormGroup>
                <div className='row'>
                  <div className='col-12'>
                    <label>Confirm New Password</label>
                  </div>
                  <div className='col-12'>
                    <Field
                      name='confirmNewPassword'
                      type='password'
                      component={InputField}
                    />
                  </div>
                </div>
              </FormGroup>
              <div className='error'>
                {error && <><ErrorIcon/>{` ${error}`}</>}
              </div>
            </div>
            <FormGroup className='buttons row'>
              <div className='col-6'>
                <button className='btn btn-accept' type='submit' disabled={invalid || submitting}>Update</button>
              </div>
              <div className='col-6'>
                <NavLink className='btn btn-cancel' to={`/`}>Cancel</NavLink>
              </div>
            </FormGroup>
          </div>
        </form>
      </div>
    )
  }
}

function onSubmit (values, dispatch) {
  values = {
    token: values.temporaryPassword,
    newPassword: values.newPassword
  }
  dispatch(resetPassword(values))
}

function validate (values) {
  let ret = {}
  if (!values.temporaryPassword || !values.temporaryPassword.trim()) {
    ret = {...ret, temporaryPassword: 'Temporary password cannot be blank'}
  }

  if (!values.newPassword || !values.newPassword.trim()) {
    ret = {...ret, newPassword: 'Password cannot be blank'}
  }

  if (values.newPassword && !validatePassword(values.newPassword)) {
    ret = {...ret, newPassword: 'New password does not meet requirements'}
  }

  if (!values.confirmNewPassword || !values.confirmNewPassword.trim()) {
    ret = {...ret, confirmNewPassword: 'Password cannot be blank'}
  }

  if (values.confirmNewPassword !== values.newPassword) {
    ret = {...ret, confirmNewPassword: 'Passwords should match'}
  }

  return ret
}

function mapStateToProps ({spinner}) {
  return {spinner}
}

const changePasswordRedux = connect(mapStateToProps)(ResetPasswordForm)

export default reduxForm({
  form: 'resetPassword',
  onSubmit: onSubmit,
  validate: validate
})(changePasswordRedux)
